import { Injectable } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { Icons } from '@inmoment/the-kitchen';

import { Document } from 'app/providers/storage-api/document.service';

export enum DefaultQuickActionsEnum {
  DELETE = 'delete',
  TAG = 'tag',
  UNTAG = 'untag',
}

export enum DefaultQuickActionIconsEnum {
  TRASH = 'trash',
  TAG = 'tag',
  TAG_FILLED = 'tag_filled',
}

export enum QuickActionInputFieldEnum {
  TITLE = 'title',
  TAG = 'tag',
}

export interface QuickActionsItem {
  id: string;
  title: string;
  enabled: boolean;
  icon: Icons;
  isEditable: boolean;
  tag: string;
  isEditMode?: boolean; // only used in the template
  tagFunction?: (document: Document) => void;
  untagFunction?: (document: Document) => void;
  deleteFunction?: (document: Document) => void;
  cardViewTagSelection?: ($event: {
    action: 'ADD' | 'REMOVE';
    tags?: string[];
    document?: Document;
  }) => void;
}

@Injectable({
  providedIn: 'root',
})
export class DocumentsQuickActionService {
  defaultQuickActions: QuickActionsItem[] = [
    {
      id: DefaultQuickActionsEnum.DELETE,
      title: translate('documents.list-settings.quick-actions.delete'),
      tag: '',
      enabled: true,
      icon: DefaultQuickActionIconsEnum.TRASH,
      isEditable: false,
    },
    {
      id: DefaultQuickActionsEnum.TAG,
      title: translate('documents.list-settings.quick-actions.tag'),
      tag: '',
      enabled: true,
      icon: DefaultQuickActionIconsEnum.TAG,
      isEditable: false,
    },
    {
      id: DefaultQuickActionsEnum.UNTAG,
      title: translate('documents.list-settings.quick-actions.untag'),
      tag: '',
      enabled: true,
      icon: DefaultQuickActionIconsEnum.TAG_FILLED,
      isEditable: false,
    },
  ];

  listOfIcons: Icons[] = [
    'add_circle',
    'action_planning',
    'anomaly_detection',
    'award',
    'cancel_circle',
    'clock',
    'comment',
    'document_report',
    'email_send',
    'favorite',
    'feedback',
    'flag',
    'game',
    'globe',
    'light',
    'lightbulb',
    'notification',
    'pin',
    'permission',
    'save',
    'star',
    'warning',
    'visibility_off',
    'circle_check',
  ];

  constructor() {}
}
